<div class="ion-padding">
  <div class="smblock-content" [innerHTML]="b.content | safeHtml"></div>
</div>